// export { default } from './ModalCertificateOrder.jsx';

import React from "react"
import ModalCertificateOrder from "./ModalCertificateOrder"
import { createRoot } from "react-dom/client"
const renderModalCertificateOrder = (toOrderValue) => {
  const body = document.querySelector("body")
  let cartContainer = document.querySelector(".js_modal_certificate_order_root")

  if (!cartContainer) {
    cartContainer = document.createElement("div")
    cartContainer.classList.add("js_modal_certificate_order_root")

    // root && render(<ModalCertificateOrder />, root);
    body.appendChild(cartContainer)
  }

  if (cartContainer) {
    const root = createRoot(cartContainer)
    root.render(<ModalCertificateOrder toOrderValue={toOrderValue} />)
  }
}
export default renderModalCertificateOrder
